import { call, put } from '@redux-saga/core/effects'
import { api, notify, apiErrorHandler } from 'services'
import {
  DownloadFileActions as Actions,
  DownloadFileRequestAction as RequestAction,
} from 'store/ducks/download'

export function* temporaryFileDownloadRequest(action: any) {
  const { fileKey, onSuccess, onFailure }: RequestAction = action;

  try {
    const url = `/temporary-files/download/${fileKey}`;
    const { data } = yield call(api.get, url);

    onSuccess && onSuccess(data);
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
